var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "card menu-bg-blue-transparent",
        style: _vm.layersListMaxHeight,
        attrs: { id: "analyticsLL" },
      },
      [
        _c(
          "div",
          { staticClass: "card-body-padding" },
          [
            _vm._m(0),
            _vm._v(" "),
            _vm.selectedExtent
              ? _c("div", { staticClass: "ml-3 mb-1" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getExtentAbbreviation()) +
                      " Coverage\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("MMP_Analytics_LayerList", {
              staticClass: "panel-height pt-3",
              attrs: {
                customerProjectId: _vm.customerProjectId,
                analyticsVisible: _vm.analyticsVisible,
                wclLayersButtonsCtrl: _vm.wclLayersButtonsCtrl,
                layerResponse: _vm.layerResponse,
                map: _vm.map,
                mmp_layersObj: _vm.mmp_layersObj,
                otonomoSubcountry: _vm.otonomoSubcountry,
                rules: _vm.rules,
                selectAllControl: _vm.selectAllControl,
                spinnerManager: _vm.spinnerManager,
                zoomEnded: _vm.zoomEnded,
                zoomLevelCap: _vm.zoomLevelCap,
                showLidarPanel: _vm.showLidarPanel,
                baseMapsOpen: _vm.baseMapsOpen,
                extentsOpen: _vm.extentsOpen,
              },
              on: {
                getErrorsLayer: function ($event) {
                  return _vm.$emit("getErrorsLayer", $event)
                },
                getFilterModal: function ($event) {
                  return _vm.getFilterModal($event.layer, $event.id)
                },
                getShowAttributes: function ($event) {
                  return _vm.$emit("getShowAttributes", $event)
                },
                layerButtonsChanged: function ($event) {
                  return _vm.$emit("layerButtonsChanged", $event)
                },
                loadAttributes: function ($event) {
                  return _vm.$emit("loadAttributes", $event)
                },
                toggleErrorsLayerVisibility: function ($event) {
                  return _vm.$emit("toggleErrorsLayerVisibility")
                },
                toggleLayers: function ($event) {
                  return _vm.toggleDRTLayers()
                },
                toggleLayerVisibility: function ($event) {
                  return _vm.$emit("toggleLayerVisibility", $event)
                },
                toTopOfList: function ($event) {
                  return _vm.$emit("toTopOfList", $event)
                },
                updateZoomEnded: function ($event) {
                  return _vm.$emit("updateZoomEnded", $event)
                },
                checkBorder: _vm.checkBorderRadius,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "ml-3 mb-1",
        staticStyle: {
          width: "100%",
          "justify-content": "space-between",
          "align-items": "center",
          display: "flex",
        },
      },
      [_c("strong", [_vm._v("Analytical Tool")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }